<template>
    <div>

<section class="content">
<div class="container-fluid">



        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Data Kecamatan</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info">
                            <th class="text-center" style="width: 5%">No.</th>
                            <th class="text-center" style="width: 10%">Kode</th>
                            <th style="width: 20%">Kecamatan</th>
                            <th style="width: 20%">Kabupaten</th>
                            <th style="width: 30%">Wilayah</th>
                            <th class="text-center" style="width: 15%">#</th>
                        </tr>
                        </thead>
                        <tbody>
                          <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                              <td class="text-center">{{index+1}}.</td>
                              <td class="text-center">{{data.kd_kecamatan}}</td>
                              <td>{{data.nm_kecamatan}}</td>
                              <td>{{data.nm_dati2}}</td>
                              <td>{{data.nm_propinsi}}</td>
                              <td class="text-center" >

                                <button @click="getView(data.id, data.nm_dati2, data.kd_dati2, data.nm_kecamatan, data.kd_kecamatan)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                    <i class="material-icons" >create</i>
                                </button>
                                &nbsp;
                                <button @click="removeData(data.id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                    <i class="material-icons" >clear</i>
                                </button>
                              </td>
                          </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                  <div class="text-center">
                      <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>
                      &nbsp;
                      <span style="font-size: 85%; color: #a5a5a5"><b>{{page_first}} - {{page_last}}</b></span>
                      &nbsp;
                      <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>
                                <div class="modal-body">

                                <div class="row clearfix">
                                  <div class="col-md-2 form-control-label">
                                      <label for="kode">Nama Kabupaten</label>
                                  </div>
                                  <div class="col-md-10">
                                    <div class="form-group">
                                      <div class="form-line">
                                        <autocomplete
                                          :url="URL+ 'api/v1/bhumie_dati2/autocomplete'"
                                          :customHeaders="{authorization: 'kikensbatara '+token }"
                                          anchor="nm_dati2"
                                          :initValue="nm_dati2"
                                          :classes="{ input: 'form-control'}"
                                          label="writer"
                                          :onShouldRenderChild="renderChild"
                                          :on-select="getAuto">
                                        </autocomplete>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row clearfix">
                                      <div class="col-md-2 form-control-label">
                                          <label for="kode">Kode Kecamatan</label>
                                      </div>
                                      <div class="col-md-10">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input v-model="kd_kecamatan" type="text" class="form-control" placeholder="Ex : 01">
                                              </div>
                                          </div>
                                      </div>
                                  </div>


                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Nama Kecamatan</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="nm_kecamatan" type="text" class="form-control" placeholder="Ex : Baruga">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                </div>
                                <div class="modal-footer">
                                    <button @click="addData" type="button" class="btn btn-info waves-effect">SIMPAN</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                  <button @click="exit_modal" type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <div class="modal-body">

                                  <div class="row clearfix">
                                  <div class="col-md-2 form-control-label">
                                      <label for="kode">Nama Kabupaten</label>
                                  </div>
                                  <div class="col-md-10" v-if="edit_data">
                                    <div class="form-group">
                                      <div class="form-line">
                                        <autocomplete
                                          :url="URL+ 'api/v1/bhumie_dati2/autocomplete'"
                                          :customHeaders="{authorization: 'kikensbatara '+token }"
                                          anchor="nm_dati2"
                                          :initValue="nm_dati2"
                                          :classes="{ input: 'form-control'}"
                                          label="writer"
                                          :onShouldRenderChild="renderChild"
                                          :on-select="getAuto">
                                        </autocomplete>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Kode Kecamatan</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="kd_kecamatan" type="text" class="form-control" placeholder="Ex : Baruga">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Nama Kecamatan</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="nm_kecamatan" type="text" class="form-control" placeholder="Ex : Baruga">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                </div>
                                <div class="modal-footer">
                                    <button @click="editData" type="button" class="btn btn-success waves-effect">RUBAH</button>
                                    <button @click="exit_modal" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- ============================================================ MODAL ======================================================================== -->




        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>
import Autocomplete from 'vue2-autocomplete-js'
const URL_SERVER = URL_APP;
const URL_DATI2 = URL_APP+'api/v1/bhumie_dati2/';
const ADD_URL = URL_APP+'api/v1/bhumie_kecamatan/';


export default {
  name: "bhumie_kecamatan",
  components: { Autocomplete },
  data() {
    return {
      id: "",
      kd_dati2: "",
      nm_dati2: "",
      nm_kecamatan: "",
      kd_kecamatan: "",

      edit_data : false,
      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",
      token : localStorage.token,
      URL : URL_SERVER


    };
  },

// =============================================================== METHODS =========================================================================
  methods : {
    getData : function(){
      fetch(ADD_URL+'view', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token
        },
        body : JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value
        })
      }).then(res => res.json())
        .then((data_res) => {
          this.list_data = data_res.data;
          this.page_last = data_res.jml_data
          // console.log(this.list_data);
        })
    },

    addData : function(){
      fetch(ADD_URL+'add', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+ localStorage.token,
        },
        body : JSON.stringify({
          kd_dati2 : this.kd_dati2,
          kd_kecamatan : this.kd_kecamatan,
          nm_kecamatan : this.nm_kecamatan
        })
      }).then((res_data)=>{
        this.alertku("success", "sukses menambah data");
        this.getData();
      });
    },

    editData : function(){
      fetch(ADD_URL+'update', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+localStorage.token
        },
        body : JSON.stringify({
          id : this.id,
          kd_dati2 : this.kd_dati2,
          nm_kecamatan : this.nm_kecamatan,
          kd_kecamatan : this.kd_kecamatan
        })
      }).then((res_data)=>{
        this.alertku("success", "sukses mengubah data");
        this.getData();
      })
    },

    removeData : function(id){
      fetch(ADD_URL+"remove", {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token,
        },
        body : JSON.stringify({
          id : id,
        })
      }).then(()=>{
        this.alertku("success", "sukses menghapus data");
        this.getData();
      })
    },

    getView : function(id,nm_dati2, kd_dati2, nm_kecamatan, kd_kecamatan){
      this.id = id;
      this.nm_dati2 = nm_dati2;
      this.kd_dati2 = kd_dati2;
      this.nm_kecamatan = nm_kecamatan;
      this.kd_kecamatan = kd_kecamatan;
      this.edit_data = true;
    },

    exit_modal : function(){
      this.edit_data = false;
    },


// ================== PAGINASI ====================
    alertku: function(type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function() {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getData();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getData();
    },

    cari_data: function() {
      this.getData();
    },
// ================== PAGINASI ====================

// ================== AUTOCOMPLETED ====================
    getAuto : function(obj){
      // console.log(obj);
      this.nm_dati2 = obj.nm_dati2;
      this.kd_dati2 = obj.kd_dati2;
    },
    renderChild(data) {
        return `
        <span><b>${data.nm_dati2}</b></span>
        <span style='font-size:80%'>${data.nm_propinsi}</span>
        `
    },
// ================== AUTOCOMPLETED ====================

  },
// =============================================================== METHODS =========================================================================

  mounted() {
    this.getData();
    // this.autocompleted();
  },
};
</script>
